import { Button } from "@/components/chadcn/Button"
import Page from "@/components/Page"
import Spinner from "@/components/Spinner"
import { useAddDeviceMutation, useSelfQuery, useUpdatePatientProfileMutation } from "@/data/queries"
import { toPatientAppStateApiDto } from "@/model/PatientAppState"
import { ROUTES, buildPath } from "@/routes"
import { useNavigate, useParams } from "react-router"

const AddDevicePage = () => {
  const { deviceCode } = useParams<{ deviceCode: string }>()
  const navigate = useNavigate()

  const { data: self, isPending: selfPending } = useSelfQuery()
  const { mutate: addDevice, isPending: addingDevice } = useAddDeviceMutation()
  const { mutate: updatePatientProfile } = useUpdatePatientProfileMutation()

  const handleConfirm = () => {
    if (!self || !deviceCode) return

    addDevice(
      { patientId: self.id, deviceCode },
      {
        onSuccess: () => {
          updatePatientProfile(
            {
              patientId: self.id,
              profile: {
                patientAppState: toPatientAppStateApiDto({
                  profileFormFilled: self.patientAppState.profileFormFilled,
                  bloodGlucoseDeviceSetupCompleted: true,
                }),
              },
            },
            {
              onSuccess: () => navigate(ROUTES.DEVICE_SETUP_COMPLETED, { replace: true }),
              onError: () => navigate(ROUTES.DEVICE_SETUP_COMPLETED, { replace: true }),
            },
          )
        },
        onError: (error) => {
          navigate(buildPath(ROUTES.DEVICE_LINKING_ERROR, {}), {
            replace: true,
            state: { error: error instanceof Error ? error.message : "unknown-error" },
          })
        },
      },
    )
  }

  if (selfPending) {
    return (
      <Page showAppbar={false}>
        <div className="flex min-h-[calc(100vh-56px)] items-center justify-center">
          <Spinner className="h-10 w-10" />
        </div>
      </Page>
    )
  }

  return (
    <Page showAppbar={false}>
      <div className="flex min-h-[calc(100vh-56px)] flex-col justify-between px-4 py-8">
        <div className="flex flex-col gap-6">
          <h1 className="text-2xl font-bold text-primary-contrast">Link device</h1>
          <p className="text-base text-primary-contrast/70">
            You are about to link device{" "}
            <span className="font-semibold text-primary-contrast">{deviceCode}</span> to your
            account.
          </p>
          <p className="text-base text-primary-contrast/70">Tap the button below to confirm.</p>
        </div>
        <Button
          type="button"
          className="w-full py-2 text-base"
          disabled={addingDevice || !deviceCode}
          onClick={handleConfirm}
        >
          {addingDevice ? <Spinner className="h-5 w-5" /> : "Confirm link"}
        </Button>
      </div>
    </Page>
  )
}

export default AddDevicePage
